import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import Logo from 'src/apps/Global/components/Nav/Logo'
import InitiativeList from 'src/apps/Initiative/components/List'
import { useMe, useOrganization } from 'src/graphql/hooks'
import ThemeContext, { Theme } from 'src/libraries/contexts/Theme'
import SidebarButton from './SidebarButton'

const GlobalViewport = ({ children }) => {
   const { organization } = useOrganization()
   const { me, isLoggedIn } = useMe()
   const theme = useContext(ThemeContext)
   const viewportBackgroundColor = '#080808'

   const groupInitiativeTypeIds = organization.initiativeTypes
      .filter(t => t.enabled && t.class === 'group')
      .map(t => t.id)

   const initiativeListFilter = {
      archived: 'exclude',
      sortBy: 'dateLastUpdated',
      typeIds: groupInitiativeTypeIds
   }

   const buttons = organization.initiativeTypes
      .filter(t => t.enabled && t.class !== 'resource' && t.class !== 'group')
      .map(t => ({
         linkTo: `/apps/${t.slug}`,
         name: t.namePlural
      }))

   return (
      <View
         position="fixed"
         top="0px"
         left="0px"
         right={theme.viewportMarginRight}
         bottom="0px"
         backgroundColor={viewportBackgroundColor}
         style={{ fontFamily: '-apple-system, inherit' }}>
         <Theme
            globalNavIsHidden
            globalNavLogoFieldName="logoDefaultNegative"
            globalNavBackgroundColor="#1e2523"
            globalNavBorderColor="#e5e5e5"
         />
         <View
            display="flex"
            justifyContent="center"
            width="100%"
            heigth="100%">
            <View
               width="100%"
               heigth="100%"
               maxWidth={theme.viewportContentMaxWidth}>
               <View
                  float="left"
                  position="relative"
                  width="250px[a-d] 270px[e] 300px[f]"
                  height="calc(100vh - 0px - 0px)"
                  scroll="on"
                  paddingTop="10px[e] 20px[f]"
                  paddingLeft="20px[a-e] 30px[f]"
                  display="none[a-c] block[d-f]"
                  alignItems="center"
                  paddingRight="15px[a-d] 20px[e-f]">
                  <View
                     display="flex"
                     alignItems="center"
                     height="90px"
                     paddingBottom="10px[e] 20px[f]"
                     position="relative"
                     left="-4px">
                     <Logo />
                  </View>
                  <View>
                     <View
                        borderTop="1px solid rgba(255,255,255,0.15)"
                        paddingTop="20px">
                        {buttons.map((button, index) => (
                           <SidebarButton
                              key={button.name}
                              linkExact={button.linkExact}
                              linkTo={button.linkTo}
                              name={button.name}
                              textSize="5[a-e] 5[f]"
                           />
                        ))}
                     </View>
                     <View
                        borderTop="1px solid rgba(255,255,255,0.15)"
                        margin="20px 0px 0px 0px"
                        padding="20px 0px">
                        <View padding="0px 0px 10px 0px">
                           <Text size="0.8" transform="uppercase" weight="medium" color="#777">
                              Channels
                           </Text>
                        </View>
                        <InitiativeList filter={initiativeListFilter}>
                           {initiativeList => initiativeList.items.map((initiative, index) => (
                              <SidebarButton
                                 key={initiative.id}
                                 icon="[ ]"
                                 linkTo={`/apps/group/${initiative.slug}`}
                                 name={initiative.name}
                                 showBadge={initiative.thread.hasUnreadEntries}
                              />
                           ))}
                        </InitiativeList>
                     </View>
                     <View>
                        <View padding="0px 0px 10px 0px">
                           <Text size="0.8" transform="uppercase" weight="medium" color="#777">
                              Direct Messages
                           </Text>
                        </View>
                        <SidebarButton
                           icon="[ ]"
                           linkTo="/messages"
                           name="John Appleseed"
                        />
                     </View>
                  </View>
                  <View
                     display="flex"
                     alignItems="center"
                     position="absolute"
                     bottom="10px"
                     left="20px"
                     right="20px"
                     borderTop="1px solid rgba(255,255,255,0.15)"
                     backgroundColor={viewportBackgroundColor}
                     padding="15px 0px">
                     <View
                        float="left"
                        width="20px"
                        height="20px"
                        marginRight="20px"
                        borderRadius="3px"
                        backgroundColor="#333"
                     />
                     {isLoggedIn && (
                        <Text size="2" color="#eee">
                           {me.fullName}
                        </Text>
                     )}
                  </View>
               </View>
               <View
                  float="left"
                  width="calc(100% - 250px)[a-d] calc(100% - 270px)[e] calc(100% - 300px)[f]"
                  height="100vh[a-d] calc(100vh - 20px)[e] calc(100vh - 40px)[f]"
                  marginTop="10px[e] 20px[f]"
                  paddingRight="10px[a-e] 20px[f]"
                  scroll="on">
                  {children}
               </View>
            </View>
         </View>
      </View>
   )
}

GlobalViewport.propTypes = {
   children: PropTypes.node.isRequired
}

export default GlobalViewport
